var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroid1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 291,
    viewBox: "0 0 268 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-96 144.632C-96 189.341 -86.9773 224.759 -68.932 250.884C-50.8867 277.009 -22.068 290.072 17.524 290.072C56.8467 290.072 85.5307 277.009 103.576 250.884C121.891 224.759 131.048 189.341 131.048 144.632C131.048 100.192 121.891 65.044 103.576 39.188C85.5307 13.0627 56.8467 0 17.524 0C-22.068 0 -50.8867 13.0627 -68.932 39.188C-86.9773 65.044 -96 100.192 -96 144.632ZM62.368 144.632C62.368 170.219 59.2707 190.015 53.076 204.02C47.1507 217.756 35.3 224.624 17.524 224.624C-0.521332 224.624 -12.6413 217.756 -18.836 204.02C-25.0307 190.015 -28.128 170.219 -28.128 144.632C-28.128 119.315 -25.0307 99.788 -18.836 86.052C-12.6413 72.316 -0.521332 65.448 17.524 65.448C35.3 65.448 47.1507 72.316 53.076 86.052C59.2707 99.5187 62.368 119.045 62.368 144.632Z",
    fill: "#DBE8F1",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M151.472 69.488V4.84801H267.016V290.476H194.296V69.488H151.472Z",
    fill: "#DBE8F1",
    fillOpacity: 0.37
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid1);
export default __webpack_public_path__ + "static/media/Android1.0e1286619bf2d184090521ad2e5ae6be.svg";
export { ForwardRef as ReactComponent };